<div class="pinch-zoom-content" [class.pz-dragging]="isDragging">
  <ng-content />
</div>

<!-- Control: one button -->
@if (isControl()) {
  <div
    class="pz-zoom-button pz-zoom-control-position-bottom"
    [class.pz-zoom-button-out]="isZoomedIn"
    (click)="toggleZoom()"
  ></div>
}
